import React from "react";

function Header({ passenger, selectedFlight }) {
  const today = new Date().toLocaleDateString("en-IN", {
    weekday: "long", day: "numeric", month: "long", year: "numeric",
  });

  return (
    <header className="app-header">
      <div className="header-left">
        <h1 className="page-title">Flight Search</h1>
        <p className="page-subtitle">{today}</p>
      </div>
      <div className="header-stats">
        <div className="hstat">
          <div className="hstat-val">6</div>
          <div className="hstat-label">Routes Available</div>
        </div>
        <div className="hstat-div" />
        <div className="hstat">
          <div className="hstat-val" style={{ color: selectedFlight ? "var(--accent)" : "var(--text-dim)" }}>
            {selectedFlight ? `₹${selectedFlight.price.toLocaleString()}` : "—"}
          </div>
          <div className="hstat-label">Selected Fare</div>
        </div>
        <div className="hstat-div" />
        <div className="hstat">
          <div className={`hstat-val ${passenger.name ? "hstat-val--green" : ""}`}>
            {passenger.name || "—"}
          </div>
          <div className="hstat-label">Passenger</div>
        </div>
      </div>
      <div className="header-actions">
        <button className="header-btn">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0"/>
          </svg>
        </button>
        <div className="header-avatar">WA</div>
      </div>
    </header>
  );
}

export default Header;